import React, { useState } from 'react';
import { LoadingButton } from 'components';
import I18n from 'core/i18n';
import { toast } from 'react-toastify';
import RenovacionDatadisServiceInstance from 'services/remote/RenovacionDatadisServiceInstance';
import { getDatadisExpirationStatus } from './datadisExpiration';
import styles from './DatadisRenewalButton.module.scss';

interface DatadisRenewalButtonProps {
  inscritoId: string;
  fechaCaducidadDatadis?: string;
  estadoRenovacionDatadis?: string;
  canRenew?: boolean;
}

export const DatadisRenewalButton = ({
  inscritoId,
  fechaCaducidadDatadis,
  estadoRenovacionDatadis,
  canRenew = true,
}: DatadisRenewalButtonProps): JSX.Element => {
  const [loading, setLoading] = useState(false);
  const [renewalSent, setRenewalSent] = useState(false);

  const sendRenewal = async (): Promise<void> => {
    setLoading(true);
    try {
      await RenovacionDatadisServiceInstance.enviarSolicitudRenovacionInscrito(inscritoId);
      setRenewalSent(true);
      toast.success(I18n.t('DatadisRenewal.sent'));
    } catch (error) {
      toast.error(I18n.t('DatadisRenewal.sendError'));
    } finally {
      setLoading(false);
    }
  };

  const renewalPendingConfirmation = renewalSent || estadoRenovacionDatadis === 'pendiente_confirmacion';
  const caducidad = getDatadisExpirationStatus(
    fechaCaducidadDatadis,
    new Date(),
    renewalPendingConfirmation ? 'pendiente_confirmacion' : estadoRenovacionDatadis,
  );
  let buttonTextKey = 'DatadisRenewal.button';

  if (renewalPendingConfirmation) {
    buttonTextKey = 'DatadisRenewal.sentToDatadis';
  } else if (loading) {
    buttonTextKey = 'DatadisRenewal.sending';
  }

  return (
    <div className={styles.root}>
      <span className={`${styles.expiration} ${styles[caducidad.status]}`}>{caducidad.text}</span>
      {canRenew && (
        <LoadingButton
          type="button"
          text={I18n.t(buttonTextKey)}
          onClick={sendRenewal}
          disabled={loading}
          variant="secondary"
        />
      )}
    </div>
  );
};
